var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('auth-header'),_c('menu-tab',{attrs:{"activeName":"exam"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }